export const paramsToQuery = params => {
	let queryString = '?'
	Object.keys(params).forEach(elem => {
		queryString = queryString.concat(`${elem}=${params[elem]}&`)
	})
	queryString = queryString.slice(0, -1)
	return queryString
}
